import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { withAnalyticsProvider, withSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import eventMapper from '../analytics/event-mapper';
import adControlWrapper from './ad-control-wrapper';
import searchApiWrapper from './search-api-wrapper';
import allhomesAnalyticsWrapper from './allhomes-analytics-wrapper';

// These HOCs need to be at the outer level
var outerLevel = [allhomesAnalyticsWrapper, withSendEvent, withAnalyticsProvider(eventMapper)];

// You can add additional HOCs that don't need a specific order here
var innerLevel = [adControlWrapper, searchApiWrapper, withAllhomesContext('watchlist', 'isSignedIn', 'createPropertyAlert', 'checkPropertyAlert', 'getAbsoluteUrl', 'user', 'localityLookup'), withMedia];
var pageWrapper = function pageWrapper() {
  for (var _len = arguments.length, additional = new Array(_len), _key = 0; _key < _len; _key++) {
    additional[_key] = arguments[_key];
  }
  return flow(...additional, ...innerLevel, ...outerLevel);
};
export default pageWrapper;